import { FETCH_ALL_COMPLETED_REQU } from '../../constants/actionTypes'

export default (laCompleted = {}, action) => {
    switch (action.type) {
        case FETCH_ALL_COMPLETED_REQU:
            return action.payload;
        default:
            return laCompleted;
    }
}